// import annIcon from '@assets/image/Icons/ann.svg';
import timeIcon from '@assets/image/Icons/time.svg';
import userIcon from '@assets/image/Icons/user.svg';
import { Col, Divider, Popover, Row } from 'antd';
import './index.scss';
const noticeStatus: any = {
  10: { color: '#00346C', backgroundColor: '#EAF7FF' },
  11: { color: '#00346C', backgroundColor: '#EAF7FF' },
  12: { color: '#500808', backgroundColor: '#FDF0F0' }
};
export const useInfoHead = ({ details = {} }: any) => {
  const { color, backgroundColor } =
    noticeStatus[details.subjectMatterProjectStatus] || {};

  const infoHeadComponent = (
    <div className="pc-infoHead-layout">
      <div className="pc-infoHead-alignFlex">
        <div className="pc-infoHead-name">项目名称：{details.noticeName}</div>
        <Row className="pc-infoHead-tip">
          <Col className="pc-infoHead-icon">
            <img src={userIcon} />
            <div>
              当前处理人：
              <Popover
                placement="bottom"
                content={
                  <>
                    <div>{details.currentProcessorUserName}</div>
                    <div>电话：{details.currentProcessorUserPhone}</div>
                    <div>邮箱：{details.currentProcessorUserEmail}</div>
                  </>
                }
              >
                <a>{details.currentProcessorUserName}</a>
              </Popover>
            </div>
          </Col>
          <Divider type="vertical" className="pc-infoHead-vertical" />
          <Col className="pc-infoHead-icon">
            <img src={timeIcon} />
            <div>创建时间：{details.createTime}</div>
          </Col>
        </Row>
      </div>
      {details?.deleteStatus ? null : (
        <div
          className="pc-pro-infoHead-btn"
          style={{ backgroundColor: backgroundColor, color: color }}
        >
          {details.subjectMatterProjectStatusValue}
        </div>
      )}
    </div>
  );
  return {
    infoHeadComponent
  };
};
